export default "__VITE_ASSET__B2oPQqD0__"